import { SourceComponents } from '@updater/informant-core';
import { Input } from '@updater/ui-uds';

export const TextField: SourceComponents['TextField'] = (props) => {
  return <Input {...props} />;
};
